import http from '@/helpers/axios';

// 测试例子 -- get
export function testByGet (id) {
  return http.request({
    url: `/api/test/${id}`,
    method: 'get'
  });
}

// 测试例子 -- post
export function test (data) {
  return http.request({
    url: '/api/test/',
    method: 'post',
    data
  });
}
// 测试商家例子 -- post
export function testCom (data) {
  return http.request({
    url: '/api/test/',
    method: 'post',
    data
  });
}

// 测试例子 -- put
export function testByPut (data) {
  return http.request({
    url: `/api/test/${data.id}`,
    method: 'put',
    data
  });
}

// 测试例子 -- delete
export function testByDelete (data) {
  return http.request({
    url: `/api/test/${data.id}`,
    method: 'delete'
  });
}

// 测试例子 -- delete
export function testByDeleteAll (data) {
  return http.request({
    url: `/api/test/delete/${data.id}`,
    method: 'post',
    data
  });
}

// -----------------------------flkj-------------------------------------

// 上传图片至oss
export function uploadImg (data) {
  return http.request({
    url: `/aido/mall/common/oss`,
    method: 'post',
    data
  });
}

// 上传附件
export function uploadfile (data) {
  return http.request({
    url: `/aido/mall/common/file/to/oss`,
    method: 'post',
    data
  });
}

// 下拉框
export function getSelect (data) {
  return http.request({
    url: `/aido/mall/common/component/select`,
    method: 'post',
    data
  });
}

//
export function getMapCode (data) {
  return http.request({
    url: `/aido/mall/common/map_code`,
    method: 'post',
    data
  });
}

//
export function getStaticDefine (data) {
  return http.request({
    url: `/aido/mall/common/static_define`,
    method: 'post',
    data
  });
}

// 获取所有的省市区
export function getProvinceCityDistrict () {
  return http.request({
    url: `/aido/mall/common/province_city_district/cascader`,
    method: 'get'
  });
}
